import React, { useState } from 'react';
import './Portfolio.css';
import Header from '../../components/header/header';

const posts = [
  { id: 10, imageUrl: require('../../assets/models_photo/7.jpg'), caption: 'Bride' },
  { id: 9, imageUrl: require('../../assets/models_photo/6.jpg'), caption: 'Bride' },
  { id: 101, imageUrl: require('../../assets/bride/101.jpeg'), caption: 'Bride' },
  // { id: 102, imageUrl: require('../../assets/bride/102.jpeg'), caption: 'Bride' },
  { id: 108, imageUrl: require('../../assets/bride/108.jpeg'), caption: 'Bride' },
  { id: 104, imageUrl: require('../../assets/bride/104.jpeg'), caption: 'Bride' },
  { id: 105, imageUrl: require('../../assets/bride/105.jpeg'), caption: 'Bride' },
  { id: 106, imageUrl: require('../../assets/bride/106.jpeg'), caption: 'Bride' },
  { id: 6, imageUrl: require('../../assets/models_photo/9.jpg'), caption: 'Bride' },
  { id: 3, imageUrl: require('../../assets/models_photo/3.jpg'), caption: 'Bride' },
  { id: 109, imageUrl: require('../../assets/bride/109.jpg'), caption: 'Bride' },
  { id: 107, imageUrl: require('../../assets/bride/107.jpeg'), caption: 'Bride' },
  { id: 110, imageUrl: require('../../assets/bride/110.jpeg'), caption: 'Bride' },
  { id: 1, imageUrl: require('../../assets/models_photo/1.jpg'), caption: 'Bride' },
  { id: 103, imageUrl: require('../../assets/bride/103.jpeg'), caption: 'Bride' },
  // { id: 8, imageUrl: require('../../assets/models_photo/5.jpg'), caption: 'Bride' },
  { id: 111, imageUrl: require('../../assets/bride/111.jpeg'), caption: 'Bride' },
  // { id: 112, imageUrl: require('../../assets/bride/112.jpeg'), caption: 'Bride' },
  { id: 113, imageUrl: require('../../assets/bride/113.jpeg'), caption: 'Bride' },
  { id: 114, imageUrl: require('../../assets/bride/114.jpeg'), caption: 'Bride' },
  { id: 115, imageUrl: require('../../assets/bride/115.jpeg'), caption: 'Bride' },
  { id: 116, imageUrl: require('../../assets/bride/116.jpeg'), caption: 'Bride' },
  { id: 117, imageUrl: require('../../assets/bride/117.jpeg'), caption: 'Bride' },
  { id: 118, imageUrl: require('../../assets/bride/118.jpeg'), caption: 'Bride' },
  { id: 119, imageUrl: require('../../assets/bride/119.jpeg'), caption: 'Bride' },
  { id: 120, imageUrl: require('../../assets/bride/120.jpeg'), caption: 'Bride' },
  { id: 121, imageUrl: require('../../assets/bride/121.jpeg'), caption: 'Bride' },
  { id: 122, imageUrl: require('../../assets/bride/122.jpeg'), caption: 'Bride' },
  { id: 123, imageUrl: require('../../assets/bride/123.jpeg'), caption: 'Bride' },
  // { id: 124, imageUrl: require('../../assets/bride/124.jpeg'), caption: 'Bride' },
  { id: 125, imageUrl: require('../../assets/bride/125.jpeg'), caption: 'Bride' },
  { id: 126, imageUrl: require('../../assets/bride/126.jpeg'), caption: 'Bride' },
    { id: 2, imageUrl: require('../../assets/models_photo/2.jpg'), caption: 'Bride' },
  { id: 4, imageUrl: require('../../assets/models_photo/4.jpg'), caption: 'Bride' },
    { id: 7, imageUrl: require('../../assets/models_photo/10.jpg'), caption: 'Bride' },

];

function Portfolio() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="portfolio-container">
      <Header />
      <div className="post-grid">
        {posts.map((post) => (
          <div className="post-card" key={post.id} onClick={() => openModal(post.imageUrl)}>
            <img src={post.imageUrl} alt={`Post ${post.id}`} />
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full Size" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Portfolio;
